module.exports = __webpack_public_path__ + "img/viewToken.1c2e146e.svg";